import { atom } from "nanostores";

import { type InvestorDetails } from "@vega-api/generated/types/investorDetails";

export const $selectedInvestor = atom<InvestorDetails | undefined>(undefined);
export const $selectedInvestorId = atom<string | undefined>(undefined);

export const investorsActions = {
  setSelectedInvestor: (user: InvestorDetails) => {
    $selectedInvestor.set(user);
    $selectedInvestorId.set(user.id);
  },
  clean: () => {
    $selectedInvestor.set(undefined);
    $selectedInvestorId.set(undefined);
  },
};
